import React, { useState } from 'react';

const ProjectionBanner = () => {
  const [isHovered, setIsHovered] = useState(false);

  const handleProjectionClick = () => {
    // 直接導航到Projection頁面，不需要彈窗
    window.location.href = '/projection';
  };

  const handleTitleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleTitleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      <section className='py-16 bg-black border-b border-white'>
        <div className='max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center'>
          <div
            className='relative inline-block cursor-default mb-8'
            onMouseEnter={handleTitleMouseEnter}
            onMouseLeave={handleTitleMouseLeave}
          >
            <h2 className='text-3xl md:text-4xl lg:text-5xl font-black text-white'>
              constellation view of all works
            </h2>
            {/* 動態下滑線 */}
            <div
              className={`absolute bottom-0 left-0 h-0.5 bg-white transition-all duration-500 ease-out ${
                isHovered ? 'w-full' : 'w-0'
              }`}
              style={{
                transitionProperty: 'width',
                transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            />
          </div>

          <button
            onClick={handleProjectionClick}
            className='bg-transparent text-white px-8 py-3 rounded-md text-lg font-medium border border-white hover:bg-purple-600 hover:text-white hover:border-transparent transition-colors duration-200'
          >
            Projection
          </button>
        </div>
      </section>
    </>
  );
};

export default ProjectionBanner;
